import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { Typography } from "@mui/material";
import Link from "@mui/material/Link";
import RouteIcon from "@mui/icons-material/Route";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export default function DashboardMainSidebar() {
  const [state, setState] = React.useState({
    right: false,
  });

  //   const dashboardList1 = ['Track Order', 'My Activity', 'Saved Address', 'My Payments', 'Favourite', 'Promotions', 'Gift Card']
  const dashboardList1 = [
    {
      title: "Track Order",
      icon: <RouteIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "My Activity",
      icon: <BoltOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Saved Address",
      icon: <GroupsOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "My Payments",
      icon: <CreditCardOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Favourite",
      icon: <FavoriteBorderOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Promotions",
      icon: <LocalOfferOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Gift Card",
      icon: <WorkspacePremiumOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
  ];

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: 377, md: 377, sm: 377, xs: "100%" },
        padding: "32px 16px",
      }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ display: "flex", flexDirection: "row", pb: "24px" }}>
        <Box sx={{ width: "56px", height: "56px" }}>
          <img
            src="./images/Drop your Memoji here.svg"
            alt=""
            width="100%"
            height="auto"
          />
        </Box>
        <Box sx={{ pl: "16px" }}>
          <Typography
            sx={{
              fontSize: {
                xl: "",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            Alex Ferguso
          </Typography>
          <Link component="button">
            <Typography
              color="primary"
              sx={{
                fontSize: {
                  xl: "",
                  lg: "14px",
                  md: "14px",
                  sm: "14px",
                  xs: "14px",
                },
              }}
            >
              View Profile
            </Typography>
          </Link>
        </Box>
      </Box>

      <List sx={{ color: "#1A1824" }}>
        <ListItemText
          primary={"My Account"}
          sx={{ color: "#9EA3AE", pb: "20px" }}
        ></ListItemText>

        {dashboardList1 &&
          dashboardList1.map((item, index) => (
            <ListItem key={item.title} disablePadding>
              <ListItemButton>
                <ListItemIcon
                  sx={{ minWidth: "24px", mr: "10px", color: "#1A1824" }}
                >
                  {/* <img width="100%" src={item.icon} alt="" /> */}
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.title} sx={{ color: "#1A1824" }} />
                {item.arrow}
              </ListItemButton>
            </ListItem>
          ))}

        <ListItem
          disablePadding
          sx={{
            backgroundColor: "#F0FAF9",
            borderRadius: "4px",
            height: "94px",
            pt: "10px",
          }}
        >
          <ListItemButton>
            <ListItemText>
              <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                Get 10% off your order
              </Typography>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "400", color: "#20615C" }}
              >
                Can only be used for today
              </Typography>
            </ListItemText>
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItemText
          primary={"General"}
          sx={{ color: "#9EA3AE", pb: "20px", mt: "8px" }}
        ></ListItemText>

        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <HelpOutlineOutlinedIcon sx={{ fill: "#1A1824" }} />
            </ListItemIcon>
            <ListItemText primary={"Help"} />
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <WorkspacePremiumOutlinedIcon sx={{ fill: "#E75C62" }} />
            </ListItemIcon>
            <ListItemText primary={"Logout"} sx={{ color: "#E75C62" }} />
            <ArrowForwardIosOutlinedIcon sx={{ fill: "#E75C62" }} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
